import localStorageHelper from '@/helpers/localStorageHelper';

const AUTH_TOKEN_KEY = 'AUTH_TOKEN';
const AUTH_TOKEN_TYPE = 'AUTH_TOKEN_TYPE';
const USER_NAME = 'USER_NAME';
const PHONE_NUMBER = 'PHONE_NUMBER';
const PDF_DETAIL_DATA = 'PDF_DETAIL_DATA';

export default class AuthService {
  static isLoggedIn() { // may not reliable if use disabled localstorage (eg. Private mode)
    return !!AuthService.getAuthToken();
  }

  static getAuthToken() {
    return localStorageHelper.getItem(AUTH_TOKEN_KEY);
  }

  static getAuthTokenType() {
    return localStorageHelper.getItem(AUTH_TOKEN_TYPE);
  }

  static removeAuthTokenType() {
    return localStorageHelper.removeItem(AUTH_TOKEN_TYPE);
  }
  
  static getAuthTelNumber() {
    return localStorageHelper.getItem(PHONE_NUMBER);
  }

  static getLoggedUserName() {
    return localStorageHelper.getItem(PHONE_NUMBER);
  }
  
  static getTopBarUserName() {
    return localStorageHelper.getItem(USER_NAME);
  }

  static getPdfDetailData() {
    return localStorageHelper.getItem(PDF_DETAIL_DATA);
  }
}
